export const LINKEDIN_MAX_DESCRIPTION_CHARS = 3000;
